export const ADD_PRODUCTS = 'ADD_PRODUCTS';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const EDIT_PRODUCT = 'EDIT_PRODUCT';
